import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useIntl } from 'react-intl';

import { formatMoney } from '../../../util/currency';
import { LINE_ITEM_NIGHT } from '../../../util/types';
import { itemValueStyles, lineItemStyles, totalDividerStyles } from './BookingBreakdown.styles';

/**
 * @param {object} props
 * @param {object} props.transaction
 * @param {'isProvider' | 'isCustomer' } props.userRole
 */

const LineItemUnitsRefundMaybe = ({ transaction, userRole }) => {
  const intl = useIntl();

  let items =
    userRole === 'provider'
      ? transaction.attributes.lineItems.filter((item) => item.includeFor.includes('provider'))
      : transaction.attributes.lineItems.filter((item) => item.includeFor.includes('customer'));

  items = items.filter((item) => item.code === LINE_ITEM_NIGHT && item.lineTotal.amount < 0);

  if (items.length === 0) return null;

  const item = items[0];
  const unitPrice = formatMoney(intl, item.unitPrice);
  const quantity = item.quantity;

  const label = intl.formatMessage(
    { id: `BookingBreakdown.quantity.${item.code.replace('line-item/', '')}` },
    { unitPrice, quantity: quantity < 0 ? quantity * -1 : quantity }
  );

  const formattedTotal = formatMoney(intl, item.lineTotal);
  const refundLabel = intl.formatMessage({ id: 'BookingBreakdown.refund' });

  return (
    <>
      <Divider sx={totalDividerStyles} />
      <Box key="night-item.code" sx={lineItemStyles}>
        <Typography sx={{ flex: 1 }} variant="lineItemLabel">{label + ' ' + refundLabel}</Typography>
        <Typography sx={itemValueStyles} variant="lineItemLabel">{formattedTotal}</Typography>
      </Box>
    </>
  );
};

export default LineItemUnitsRefundMaybe;
